<template>
    <div class="row">
        <div class="form-group col-12 px-0">
            <div class="input-group">
                <div class="col-6 col-md-4">
                    <input type="text" class="form-control" readonly
                           v-model="identification.identificationType"
                           :name="'identificationType' + _uid" />
                </div>
                <div class="col-6 col-md-8">
                    <input type="text" class="form-control" readonly
                           v-model="identification.number"
                           :name="'identificationNumber' + _uid" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { PersonIdentificationDetails } from '../../models/models';

    export default {
        props: {
            identification: {
                type: Object,
                default: new PersonIdentificationDetails({})
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
